import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@capacit-com/lara-law-shared-ui";
import { FC } from "react";
import { useConversationHub } from "@/hooks/useConversationHub";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronsLeftIcon,
  ChevronsRightIcon,
} from "lucide-react";
export type SmallPaginationProps = {
  testId?: string;
};

const SmallPagination: FC<SmallPaginationProps> = ({ testId }) => {
  const {
    pageNumber,
    pageCount,
    handleNextPage,
    handlePreviousPage,
    setPageNumber,
  } = useConversationHub();
  const handlePageChange = (value: string) => {
    setPageNumber(parseInt(value));
  };

  const handleFirstPage = (event: React.MouseEvent) => {
    event.preventDefault();
    setPageNumber(1);
  };

  const handleLastPage = (event: React.MouseEvent) => {
    event.preventDefault();
    setPageNumber(pageCount);
  };

  return (
    <div
      className="flex items-center justify-between border-t py-2 h-12"
      data-testid={testId}
    >
      <div className="flex flex-1  items-center justify-around">
        <div className="flex items-center gap-2 justify-center">
          <button
            onClick={handleFirstPage}
            disabled={pageNumber === 1}
            className={`px-2 py-1 rounded-sm ${
              pageNumber === 1
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-accent-foreground/15 transition-all duration-300 cursor-pointer"
            }`}
            data-testid={`${testId}-first`}
          >
            <ChevronsLeftIcon className="size-4" />
          </button>
          <button
            onClick={handlePreviousPage}
            disabled={pageNumber === 1}
            className={`px-2 py-1 rounded-sm ${
              pageNumber === 1
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-accent-foreground/15 transition-all duration-300 cursor-pointer"
            }`}
            data-testid={`${testId}-previous`}
          >
            <ChevronLeftIcon className="size-4" />
          </button>
        </div>

        <div className="flex items-center justify-center">
          <Select
            value={pageNumber.toString()}
            onValueChange={handlePageChange}
          >
            <SelectTrigger className="!h-6 px-2 py-0 w-18 text-center justify-between cursor-pointer">
              <SelectValue>{pageNumber}</SelectValue>
            </SelectTrigger>
            <SelectContent>
              {Array.from({ length: pageCount }, (_, i) => i + 1).map(
                (page) => (
                  <SelectItem
                    key={page}
                    value={page.toString()}
                    className="cursor-pointer"
                  >
                    {page}
                  </SelectItem>
                )
              )}
            </SelectContent>
          </Select>
        </div>

        <div className="flex items-center justify-center">
          <button
            onClick={handleNextPage}
            disabled={pageNumber === pageCount}
            className={`px-2 py-1 rounded-sm ${
              pageNumber === pageCount
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-accent-foreground/15 transition-all duration-300 cursor-pointer"
            }`}
            data-testid={`${testId}-next`}
          >
            <ChevronRightIcon className="size-4" />
          </button>
          <button
            onClick={handleLastPage}
            disabled={pageNumber === pageCount}
            className={`px-2 py-1 rounded-sm ${
              pageNumber === pageCount
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-accent-foreground/15 transition-all duration-300 cursor-pointer"
            }`}
            data-testid={`${testId}-last`}
          >
            <ChevronsRightIcon className="size-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SmallPagination;
